/** Desktop watchlist table — compact styling aligned with open positions / history. */

export {
  DESKTOP_HISTORY_TABLE_CLASS as WATCHLIST_TABLE_CLASS,
  historyTh as watchlistTh,
  historyTd as watchlistTd,
} from "@/components/history-view/content/historyDesktopTableLayout";

// Icon (14px) + quote badge + gap ahead of the name.
export const WATCHLIST_SYMBOL_COL_WIDTH = "w-[7.5rem]";

export function getWatchlistColumnWidth(columnName: string): string {
  switch (columnName) {
    case "Time":
      return "w-[4.5rem]";
    case "Day %":
      return "w-14";
    case "Spread":
      return "w-14";
    case "Bid":
    case "Ask":
    case "Last":
      return "w-16";
    case "Bid High":
    case "Bid Low":
    case "Ask High":
    case "Ask Low":
    case "Last High":
    case "Last Low":
      return "w-16";
    default:
      return "w-16";
  }
}

export function watchlistColSpan(columnCount: number): number {
  return 1 + columnCount;
}
